export default function initKasselogin() {
    document.querySelectorAll('[data-accordion]').forEach((acc) => {
        acc.addEventListener('click', (e) => {
            if (e.target.closest('[data-accordion-content]')) return;
            acc.classList.toggle('is-open');
        });
    });
}
